import  * as React from 'react'
// Bilder und PDfs
import { StaticImage } from 'gatsby-plugin-image'; // Bilder

// Translation
import {useI18next} from 'gatsby-plugin-react-i18next'
import { graphql } from 'gatsby';
//components
import Layout from '../../components/layout/layout'
import { Seo } from '../../components/seo';

//const: data eingefügt für PDFS hochladen
const Linotech  = ({data}) => {
    const {t} = useI18next();
    return (
        <Layout pageTitle={t('title')} subTitle={t('subtitle')}>
          {/* Block mit weissem hintergrund 
          <div className='row'>

            <div className='col-12'>
              <div className='container'>
                <BoxInfo description={t('text')} />
              </div>
            </div>
          </div>
        */}
          <div className='row'>
            {/* 1 oder mehr Blöcke am Anfang: Titel und Text / ggf später ein Bild */}
            <div className='col-12'>
              <div className='container'>
                {/* 1. die Firma */}
                <h2 align="left"> {t('title1')} </h2>
                <p> {t('text1')} </p>
                 {/* 2. Ansprechpartner */}
                <h2 align="left"> {t('title2')} </h2>
                <p> <b>{t('text21')} </b> {t('text212')}</p>
                <p> <b>{t('text22')} </b> {t('text222')}</p>
                <p> <b>{t('text23')} </b> {t('text232')}</p>
                {/* 3. Kontakt */}
                <h2 align="left"> {t('title3')} </h2>
                <p> {t('text31')} </p>
                <p> {t('text32')} </p>
                <p> {t('text33')} </p>
                <p> {t('text34')} </p>                
                <p> {t('text35')} </p>
                <p> {t('text36')} </p>


                {/* 4. AGBS */}
                <h2 align="left"> {t('title4')} </h2>
                <p> {t('text41')} 
                </p>  
                <p>  
                  <a href={data.pdfltagb.publicURL} download>{t('text42')} </a>
                  <div>
                  <a href={data.pdfltgtc.publicURL} download>{t('text43')} </a>
                  </div> 
                </p>  

                {/*         
                <h2 align="left"> {t('title5')} </h2>
                <p> {t('text51')} </p>
                <p> {t('text52')} </p>

                <h2 align="left"> {t('title6')} </h2>
                <p> {t('text61')} </p>
            
                <p>{t('bildtext1')}</p>              : ggf ein Bild einfügen / passt hier aber nicht
                <StaticImage alt="ein bild" src="../images/CAD-Zeichnungen-RK.jpg"/> */}
              </div>
            </div>
          </div>
        </Layout>

    );
};

export default Linotech

// Fuer Search engine optimizationjj
export const Head = () =>( <Seo title="Linotech" keywords="Compounds" /> )

// Für Mehrsprachigkeit, graphql muss am anfang import werden!
// pdf: Definition der Variablen

export const query = graphql`
query ($language: String!) 
  {
    pdfltagb: file(relativePath: {eq: "Allgemeine Verkaufs- und Lieferbedingungen Linotech-V2.pdf"}) 
      {
          publicURL
          name
      }
    pdfltgtc: file(relativePath: {eq: "Linotech General Terms and Conditions of Sale and Delivery-V2.pdf"}) 
      {
          publicURL
          name
      }

    locales: allLocale
    (
      filter: { ns: { in: ["linotech"] }, language: { eq: $language } }
    ) 
    {
      edges 
      {
        node 
        {
         ns
         data
         language
        }
      }
      }
  }
`;